// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__PxxIj","container":"Footer_container__iICw7","logo":"Footer_logo__w79hm","info":"Footer_info__SuIsf","link":"Footer_link__sgKeT","map":"Footer_map__QMOwk"};